import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useUpdateCoddingManual = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const getData = guid => {
    if (!guid) return;

    setLoading(true);
    setError(false);

    axiosClient
      .get(`Product/Branch/Codding/Manual/Update`, { params: { GUID: guid } })
      .then(res => {
        if (res.status === 200 && res.data?.result !== false) {
          setData(res.data?.value ?? null);
        } else {
          setError(true);
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        setError(true);
        enqueueSnackbar(err?.message || 'خطایی در برقراری ارتباط رخ داد.', {
          variant: 'error',
        });
      })
      .finally(() => setLoading(false));
  };

  const update = ({ guid, title, code, titleRequired }, onSuccess) => {
    if (!guid) return;

    setLoading(true);

    axiosClient
      .put(`Product/Branch/Codding/Manual/Update`, {
        guid,
        title,
        code,
        titleRequired: !!titleRequired,
      })
      .then(res => {
        if (res.status === 200) {
          if (onSuccess) onSuccess();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err =>
        enqueueSnackbar(err?.message || 'خطایی در برقراری ارتباط رخ داد.', {
          variant: 'error',
        }),
      )
      .finally(() => setLoading(false));
  };

  return { update, getData, loading, data, error, setData };
};

export default useUpdateCoddingManual;
